export const DEFAULT_SLOTS = {
  SLOT_1: null,
  SLOT_2: null,
  SLOT_3: null,
  SLOT_4: null,
  SLOT_5: null,
  SLOT_6: null,
  SLOT_7: null,
  SLOT_8: null,
}

export const DEFAULT_TEMPLATES = [
  { name: 'Template A', template: 'Gutenberg', tags: ['4 KPI', '1 Viz'], slots: DEFAULT_SLOTS },
  { name: 'Template B', template: 'Hugo', tags: ['4 KPI', '2 Viz'], slots: DEFAULT_SLOTS },
  { name: 'Template C', template: 'Lovelace', tags: ['8 KPI'], slots: DEFAULT_SLOTS },
  { name: 'Template D', template: 'NotreDame', tags: ['4 KPI' , '1 Viz'], slots: DEFAULT_SLOTS }
]